/**
 * WaterTile - Water hazard (deadly without flippers)
 */

import Phaser from "phaser";
import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";
import { GAME_CONFIG, COLORS } from "../config";

export class WaterTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `water-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.WATER;
  }

  textureDescriptor(): TextureDescriptor {
    return {
      type: "procedural",
      generator: (scene: Phaser.Scene, key: string) => {
        WaterTile.generateTexture(scene, key);
      },
    };
  }

  static generateTexture(scene: Phaser.Scene, key: string): void {
    const size = GAME_CONFIG.tileSize;
    const graphics = scene.add.graphics();

    // Water background
    graphics.fillStyle(COLORS.water, 1);
    graphics.fillRect(0, 0, size, size);

    // Wave pattern (lighter blue lines)
    graphics.lineStyle(3, 0x66bbff, 0.6);
    for (let i = 0; i < 3; i++) {
      const y = 11 + i * 15;
      graphics.beginPath();
      graphics.moveTo(0, y);
      graphics.lineTo(11, y - 5);
      graphics.lineTo(21, y);
      graphics.lineTo(32, y - 5);
      graphics.lineTo(size, y);
      graphics.strokePath();
    }

    // Border
    graphics.lineStyle(1, 0x2266aa, 0.5);
    graphics.strokeRect(0, 0, size, size);

    graphics.generateTexture(key, size, size);
    graphics.destroy();
  }

  clone(): WaterTile {
    const copy = new WaterTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "water", id: this.id, col: this.col, row: this.row };
  }
}
